import { jsx as _jsx } from "react/jsx-runtime";
import { SiteFooter } from '@eventbrite/legacy-infra.site-footer';
import { useIntl } from 'react-intl';
import { LOCALE_LIST } from './localeInfo.js';
export function Footer({ serverUrl, localeInfo, isUserAuthenticated, globalFooterProps, }) {
    const { showMinimalLinks, thirdFooterColumn = [], popularSearches, eventsToPlan, impressumHelpLink, } = globalFooterProps;
    const intl = useIntl();
    const trimmedServerUrl = serverUrl.replace(/\/$/, '');
    const handleLocaleChange = (locale) => {
        if (typeof window !== 'undefined') {
            window.location.assign(`${trimmedServerUrl}/international/change_locale/?locale=${locale}`);
        }
    };
    return (_jsx("div", { "data-testid": "app-shell-footer", children: _jsx(SiteFooter, { serverUrl: trimmedServerUrl, showMinimalLinks: showMinimalLinks, showMarketingLinks: !isUserAuthenticated, isUserAuthenticated: isUserAuthenticated, locales: LOCALE_LIST, localeInfo: localeInfo, onLocaleChange: handleLocaleChange, thirdFooterColumn: thirdFooterColumn || [], thirdFooterColumnName: intl.formatMessage({
                id: 'Find Events',
                defaultMessage: 'Find Events',
            }), popularSearches: popularSearches, eventsToPlan: eventsToPlan, helpLinks: { impressum: impressumHelpLink } }) }));
}
export default Footer;
